<!-- error.vue -->

<script setup lang="ts">
	const props = defineProps({
		error: Object,
	});

	onMounted(() => {
		const errorMsg = String(props.error?.message || props.error?.statusMessage || "");

		// 僅當錯誤訊息包含 dynamically imported 關鍵字時才觸發清除
		if (errorMsg.includes("Failed to fetch dynamically imported module") || errorMsg.includes("Importing a module script failed")) {
			if (!sessionStorage.getItem("chunk_rescue_attempted")) {
				sessionStorage.setItem("chunk_rescue_attempted", "true");

				// 清除 SW & 快取
				if ("serviceWorker" in navigator) {
					navigator.serviceWorker.getRegistrations().then((regs) => {
						regs.forEach((r) => r.unregister());
					});
				}
				if ("caches" in window) {
					caches.keys().then((keys) => {
						keys.forEach((k) => caches.delete(k));
					});
				}

				// 自動刷新
				const cleanUrl = window.location.href.split("?")[0];
				window.location.href = `${cleanUrl}?v=${Date.now()}`;
			}
		}
	});

	// 正常 500 錯誤的處理
	const handleError = () => clearError({ redirect: "/" });
</script>

<template>
	<div class="error-page">
		<h1>{{ error?.statusCode || 500 }}</h1>
		<p>{{ error?.message || "系統發生錯誤" }}</p>
		<button @click="handleError">返回首頁</button>
	</div>
</template>
